import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../Admin.css';

const AffiliateSettings = () => {
    const navigate = useNavigate();
    const [settings, setSettings] = useState({
        amazon: { tag: '', enabled: true },
        magalu: { id: '', enabled: true },
        shopee: { appId: '', secret: '', enabled: true },
        mercadolivre: { clientId: '', clientSecret: '', accessToken: '', sessionCookie: '', enabled: true }
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/affiliate/settings`);
            setSettings(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Erro ao carregar configurações:', error);
            setMessage({ type: 'error', text: 'Erro ao carregar configurações.' });
            setLoading(false);
        }
    };

    const handleChange = (platform, field, value) => {
        setSettings(prev => ({
            ...prev,
            [platform]: {
                ...prev[platform],
                [field]: value
            }
        }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setMessage(null);

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/affiliate/settings`, settings);
            setMessage({ type: 'success', text: 'Configurações salvas com sucesso!' });
        } catch (error) {
            console.error('Erro ao salvar:', error);
            setMessage({ type: 'error', text: 'Erro ao salvar configurações.' });
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="loading">Carregando...</div>;

    return (
        <div className="admin-content">
            <div className="header-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                    <h1>Configurações de Afiliado</h1>
                    <p>Gerencie seus IDs e Tags para gerar links automaticamente.</p>
                </div>
                <button
                    className="btn-secondary"
                    onClick={() => navigate('/dashboard')}
                    style={{ marginTop: '5px' }}
                >
                    <i className="fas fa-arrow-left"></i> Voltar ao Dashboard
                </button>
            </div>

            {message && (
                <div className={`alert ${message.type === 'error' ? 'alert-danger' : 'alert-success'}`} style={{ marginBottom: '20px', padding: '10px', borderRadius: '5px', backgroundColor: message.type === 'error' ? '#ffebee' : '#e8f5e9', color: message.type === 'error' ? '#c62828' : '#2e7d32' }}>
                    {message.text}
                </div>
            )}

            <div className="card-container">
                <form onSubmit={handleSave}>
                    {/* Amazon */}
                    <div className="form-section" style={{ marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, marginRight: '10px' }}>Amazon</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={settings.amazon.enabled}
                                    onChange={(e) => handleChange('amazon', 'enabled', e.target.checked)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <div className="form-group">
                            <label>Tag de Associado (Store ID)</label>
                            <input
                                type="text"
                                value={settings.amazon.tag}
                                onChange={(e) => handleChange('amazon', 'tag', e.target.value)}
                                placeholder="Ex: otymafarma-20"
                                className="form-input"
                            />
                            <small>Sua tag será adicionada automaticamente aos links da Amazon (ex: ?tag=suatag-20)</small>
                        </div>
                    </div>

                    {/* Magazine Luiza */}
                    <div className="form-section" style={{ marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, marginRight: '10px' }}>Magazine Luiza</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={settings.magalu.enabled}
                                    onChange={(e) => handleChange('magalu', 'enabled', e.target.checked)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <div className="form-group">
                            <label>ID do Magazine Você</label>
                            <input
                                type="text"
                                value={settings.magalu.id}
                                onChange={(e) => handleChange('magalu', 'id', e.target.value)}
                                placeholder="Ex: nomedasualoja"
                                className="form-input"
                            />
                            <small>Links do magazineluiza.com.br serão convertidos para magazinevoce.com.br/magazineSEUID</small>
                        </div>
                    </div>

                    {/* Shopee (Placeholder) */}
                    <div className="form-section" style={{ marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, marginRight: '10px' }}>Shopee</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={settings.shopee.enabled}
                                    onChange={(e) => handleChange('shopee', 'enabled', e.target.checked)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>App ID (Shopee Affiliate)</label>
                            <input
                                type="text"
                                value={settings.shopee.appId || ''}
                                onChange={(e) => handleChange('shopee', 'appId', e.target.value)}
                                placeholder="Seu AppID da Shopee"
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label>API Secret</label>
                            <input
                                type="password"
                                value={settings.shopee.secret || ''}
                                onChange={(e) => handleChange('shopee', 'secret', e.target.value)}
                                placeholder="Sua Senha da API Shopee"
                                className="form-input"
                            />
                            <small>Sua chave de acesso à API oficial da Shopee (Dashboard de Afiliados).</small>
                        </div>
                    </div>
                    
                    {/* Mercado Livre */}
                    <div className="form-section" style={{ marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                            <h3 style={{ margin: 0, marginRight: '10px' }}>Mercado Livre</h3>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={settings.mercadolivre.enabled}
                                    onChange={(e) => handleChange('mercadolivre', 'enabled', e.target.checked)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Client ID (Meli Developers)</label>
                            <input
                                type="text"
                                value={settings.mercadolivre.clientId || ''}
                                onChange={(e) => handleChange('mercadolivre', 'clientId', e.target.value)}
                                placeholder="Seu ID da Aplicação no ML"
                                className="form-input"
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Client Secret</label>
                            <input
                                type="password"
                                value={settings.mercadolivre.clientSecret || ''}
                                onChange={(e) => handleChange('mercadolivre', 'clientSecret', e.target.value)}
                                placeholder="Seu Secret da Aplicação no ML"
                                className="form-input"
                            />
                        </div>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label>Access Token (API Developers)</label>
                            <input
                                type="text"
                                value={settings.mercadolivre.accessToken || ''}
                                onChange={(e) => handleChange('mercadolivre', 'accessToken', e.target.value)}
                                placeholder="Seu Access Token"
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label>Session Cookie (Automação n8n/Cache)</label>
                            <textarea
                                value={settings.mercadolivre.sessionCookie || ''}
                                onChange={(e) => handleChange('mercadolivre', 'sessionCookie', e.target.value)}
                                placeholder="Cole seu Cookie do ML aqui"
                                className="form-input"
                                style={{ height: '80px', fontFamily: 'monospace', fontSize: '0.8rem' }}
                            />
                            <small>Use este campo para colar o cookie de uma sessão ativa do Mercado Livre (como você faz no n8n).</small>
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="submit" className="btn-primary" disabled={saving}>
                            {saving ? 'Salvando...' : 'Salvar Configurações'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AffiliateSettings;
